<template>
  <div class="card-container">
    <div class="card" v-for="(cardData, _card_i) in parsedListProcessed" :key="`mobile_list_${_card_i}`">
      <div class="card-header">
        <div class="card-number status-badge">{{ cardData.No }}</div>
        <div class="card-title">{{ cardData.작업명 }}</div>
      </div>

      <div class="info-grid">
        <div class="info-item">
          <svg class="info-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
          </svg>
          <span class="info-label">사업장명:</span>
          <span class="info-value">{{ cardData.사업장명 }}</span>
        </div>

        <div class="info-item">
          <svg class="info-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
          </svg>
          <span class="info-label">작성자:</span>
          <span class="info-value">{{ cardData.작성자 }}</span>
        </div>

        <div class="info-item">
          <svg class="info-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"
            />
          </svg>
          <span class="info-label">일 안전작업허가 연계여부:</span>
          <span class="info-value"> {{ cardData.일안전작업허가연계여부 ? "Y" : "N" }}</span>
        </div>

        <div class="info-item">
          <svg class="info-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          <span class="info-label">상태:</span>
          <span class="status-badge" :style="{ backgroundColor: cardData.상태.color }">{{ cardData.상태.text }}</span>
        </div>

        <div class="info-item">
          <svg class="info-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"
            />
          </svg>
          <span class="info-label">위험성평가 D/B 연계:</span>
          <span class="info-value">{{ cardData.위험성평가DB연계 ? "Y" : "N" }}</span>
        </div>
      </div>

      <div class="section-divider"></div>

      <button class="action-button" @click="() => onClickDetail(cardData)">
        <svg width="20" height="20" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
        내용 보기
      </button>
    </div>

    <slot name="empty"></slot>
    <slot name="pagenation"></slot>
  </div>
</template>

<script>
export default {
  props: {
    parsedListForTable: {
      type: Array,
      required: true,
    },
  },
  computed: {
    parsedListProcessed() {
      return this.parsedListForTable.map((item) => {
        const newItem = { ...item };

        const bodyData = JSON.parse(newItem.raw.post_content).body;

        newItem.일안전작업허가연계여부 = !!bodyData.연결된일작업허가서;

        const 잠재위험요인 = bodyData.잠재위험요인;
        newItem.위험성평가DB연계 = this.hasAnyRiskEvaluation(잠재위험요인);

        // 모든 키에 대해 <br> 태그 제거
        Object.keys(newItem).forEach((key) => {
          const cleanedKey = key.replace(/<br\s*\/?>/gi, ""); // 모든 <br>, <br/>, <br />, <br > 제거
          if (cleanedKey !== key) {
            newItem[cleanedKey] = newItem[key];
            delete newItem[key];
          }
        });

        // 2. 작업유형 문자열 -> 배열로 변환
        if (typeof newItem["작업유형"] === "string") {
          newItem["작업유형"] = newItem["작업유형"]
            .split(",")
            .map((v) => v.trim()) // 공백 제거
            .filter(Boolean); // 빈 문자열 제거
        }

        return newItem;
      });
    },
  },
  methods: {
    onClickDetail(item, target = "self") {
      this.$emit("selected", item, target);
    },
    hasAnyRiskEvaluation(data) {
      return data.some((item) => item.hasOwnProperty("위험성평가"));
    },
  },
};
</script>

<style lang="scss" scoped>
.card-container {
  margin: 0 auto;
  border-radius: 12px;
  padding: 1rem;
}

.card {
  background: white;
  border-radius: 16px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  padding: 24px;
  margin-bottom: 20px;
  position: relative;
}

.card-header {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}

.card-number {
  background: #6670cb;
  color: white;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 14px;
  margin-right: 12px;
}

.card-title {
  font-size: 16px;
  font-weight: bold;
  color: #374151;
  line-height: 1.4;
}

.progress-section {
  margin-bottom: 20px;
}

.progress-label {
  font-size: 14px;
  color: #6b7280;
  margin-bottom: 8px;
}

.progress-bar {
  background: #e5e7eb;
  height: 8px;
  border-radius: 4px;
  overflow: hidden;
  margin-bottom: 8px;
}

.progress-fill {
  background: #7c3aed;
  height: 100%;
  width: 91.06%;
  border-radius: 4px;
}

.progress-text {
  font-size: 14px;
  font-weight: bold;
  color: #7c3aed;
  text-align: right;
}

.info-grid {
  display: grid;
  gap: 16px;
  background-color: #f3f4f6;
  padding: 16px;
  border-radius: 8px;
  margin-bottom: 20px;
}

.section-divider {
  height: 1px;
  background: #e5e7eb;
  margin-bottom: 20px;
}

.info-item {
  display: flex;
  align-items: center;
}

.info-icon {
  width: 20px;
  height: 20px;
  margin-right: 12px;
  flex-shrink: 0;
}

.info-label {
  font-size: 13px;
  color: #6b7280;
  margin-right: 8px;
  min-width: 80px;
}

.info-value {
  font-size: 14px;
  font-weight: 600;
  color: #374151;
}

.status-badge {
  background: #6670cb;
  color: white;
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
}

.action-button {
  background: #10b981;
  color: white;
  border: none;
  padding: 14px 24px;
  border-radius: 12px;
  font-size: 16px;
  font-weight: 600;
  width: 100%;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}
</style>
